import * as sup from "superstruct";

import { JsonApiClient } from "@/modules/api/utils/createJsonApiClient/createJsonApiClient";
import { createResponseStruct } from "@/modules/api/utils/jsonApiStructs";
import { userResourceStruct } from "@/modules/auth/api/resources/user/userResourceStruct";

import { getSubtaskResourcePath } from "../resources/subtask/subtaskResourceConsts";
import { subtaskResourceStruct } from "../resources/subtask/subtaskResourceStruct";

export const getSubtaskQuery = (
  jsonApi: JsonApiClient,
  { userGroupId, subtaskId }: { userGroupId: string; subtaskId: string }
) => {
  return jsonApi.getOne({
    path: getSubtaskResourcePath(userGroupId, subtaskId),
    responseStruct: getSubtaskResponseStruct,
  });
};

const getSubtaskResponseStruct = createResponseStruct({
  data: subtaskResourceStruct,
  included: sup.array(userResourceStruct),
});

export type GetSubtaskResponse = sup.Infer<typeof getSubtaskResponseStruct>;
